export default [
    {
        path: "/quotations",
        name: "quotations",
        component: () => import('@/views/modules/quotations/list'),
        meta: {
            requiresAuth: true,
            layout: "app",
            title: "Quotations List",
            breadcrumb: [
                { text: "Home", to: { name: "home" } },
                { text: "Quotations" }
            ]
        }
    },

    {
        path: "/quotations/create",
        name: "quotations-create",
        component: () => import("@/views/modules/quotations/create"),
        meta: {
            sidebarToggle: false,
            requiresAuth: true,
            layout: "app",
            title: "Quotation Create",
            breadcrumb: [
                { text: "Home", to: { name: "home" } },
                { text: "Create" }
            ]
        }
    },
    {
        path: "/quotations/rep-quotations",
        name: "quotations-rep-quotations",
        component: () => import("@/views/modules/quotations/rep-quotations"),
        meta: {
            sidebarToggle:false,
            requiresAuth: true,
            layout: "app",
            title: "My Quotations",
            breadcrumb: [
                { text: "Home", to: { name: "home" } },
                { text: "My Quotations" }
            ]
        }
    },

    {
        path: "/pricelist/create",
        name: "pricelist-create",
        component: () => import("@/views/modules/quotations/pricelist-create"),
        meta: {
            sidebarToggle: false,
            requiresAuth: true,
            layout: "app",
            title: "Pricelist Create",
            breadcrumb: [
                { text: "Home", to: { name: "home" } },
                { text: "Create" }
            ]
        }
    },
   
    
];
